<template>
  <div class="page">
    <v-container fluid>
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <div class="pa-6">
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="3"></v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.nome"
                label="Nome do Calendário"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="3"></v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="6">
              <v-text-field
                :value="content.anoCalendario"
                label="Ano Calendário"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.periodo"
                label="Período do Calendário"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="d-flex justify-center mt-7">
            <v-col cols="6">
              <v-text-field
                :value="content.diasLetivos"
                label="Dias Letivos"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                :value="content.vigente ? 'Sim' : 'Não'"
                label="Calendário Vigente"
                readonly
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-6 mb-2">
            <v-btn color="primary" dark @click="adicionarEvento" v-if="!isView">
              <v-icon left>mdi-calendar-plus</v-icon>
              Adicionar Evento
            </v-btn>
          </v-row>
        </div>
      </v-card>
    </v-container>
    <v-dialog v-model="dialogAdicionarEvento" persistent max-width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-plus</v-icon>
            Adicionar Evento ao Calendário
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" @submit.prevent="salvarEvento">
            <v-row class="d-flex justify-center mt-7">
              <sca-date-picker
                :cols="6"
                label="Data do Evento*"
                v-model="formEvento.dataInicio"
                :allowedDates="permitirSomenteAnoCalendario"
                removeIcon
                outlined
                dense
              />
              <sca-date-picker
                :cols="6"
                label="Data Fim do Evento*"
                v-model="formEvento.dataFim"
                :allowedDates="permitirSomenteAnoCalendario"
                removeIcon
                outlined
                dense
              />
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="formEvento.eventosSelecionados"
                  :items="eventos"
                  item-text="nome"
                  item-value="id"
                  label="Eventos*"
                  dense
                  outlined
                  hide-details
                  return-object
                  multiple
                  chips
                />
              </v-col>
            </v-row>
            <v-row class="d-flex justify-center" v-if="formEvento.eventosSelecionados?.length">
              <v-col cols="12">
                <span class="small">Eventos Selecionados</span>
                <v-chip-group active-class="primary--text" column>
                  <v-chip
                    v-for="evento in formEvento.eventosSelecionados"
                    :key="evento.id"
                    :color="evento.corHexadecimal"
                    dark
                  >
                    {{ evento.nome }}
                  </v-chip>
                </v-chip-group>
              </v-col>
            </v-row>
            <sca-buttons
              @click="salvarEvento()"
              @cancel="cancelarEvento()"
              :actionText="'Salvar'"
            ></sca-buttons>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
    <sca-calendario
      :eventos="eventosCalendario"
      :anoCalendario="content.anoCalendario"
      :isView="isView"
      :start="inicioVisualizacao"
      @removerEvento="excluirEventoCalendario"
    />
    <sca-buttons
      :showAction="false"
      :showCancel="true"
      cancelText="Voltar"
      @cancel="voltar()"
    />

  </div>
</template>
<script>
import CalendarioService from '~/services/calendario.service';
import EventoCalendarioService from '~/services/evento-calendario.service';
export default {
  name: 'GerenciarCalendárioEventos',
  mixins: [CalendarioService, EventoCalendarioService],
  data() {
    return {
      content: {},
      dialogAdicionarEvento: false,
      eventos: [],
      eventosCalendario: [],
      formEvento: {
        dataInicio: null,
        dataFim: null,
        periodo: false,
        eventoSelecionados: [],
      },
    };
  },
  computed: {
    isView() {
      return this.$route.query.isView === 'true' || this.$route.query.isView === true;
    },
    inicioVisualizacao() {
      const anoAtual = new Date().getFullYear();
      const mesAtual = new Date().getMonth() + 1;
      if (this.content?.anoCalendario === anoAtual) {
        return `${anoAtual}-${String(mesAtual).padStart(2, '0')}-01`;
      }
      if (this.content?.anoCalendario && this.content?.mesInicio) {
        return `${this.content.anoCalendario}-${String(this.content.mesInicio).padStart(2, '0')}-01`;
      }
      return new Date().toISOString().substr(0, 10);
    }
  },
  methods: {
    cancelarEvento() {
      this.resetarFormEvento();
      this.dialogAdicionarEvento = false;
    },
    permitirSomenteAnoCalendario(data) {
      if (!data || !this.content.anoCalendario) return false;
      const ano = typeof data === 'string' ? Number(data.split('-')[0]) : new Date(data).getFullYear();
      return ano === this.content.anoCalendario;
    },


    excluirEventoCalendario(evento) {
      if (this.isView) return;
      const calendarioId = this.content.id;
      const atividadeId = evento.original?.eventoCalendarioAtividadeId;
      this.$excluirEventoDiaCalendario(calendarioId, atividadeId)
        .then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.buscarCalendario(calendarioId);
        })
        .catch(() => {
          this.$notifyError('Erro ao excluir o evento.');
        });
    },

    buscarCalendario(id) {
      this.$visualizarCalendario({ id })
        .then(({ data }) => {
          this.content = data.calendario;
          this.eventosCalendario = (data.calendario.atividades || []).flatMap(atividade =>
            (atividade.eventos || []).map(evento => ({
              name: evento.nome,
              start: atividade.dataInicio.split('T')[0],
              end: atividade.dataFinal.split('T')[0],
              color: evento.corHexadecimal,
              original: evento
            }))
          );
        })
      .catch(() => {
        this.$notifyError('Erro ao buscar dados do calendário.');
      });
    },

    buscarEventos() {
      this.$buscarEventoCalendarios()
        .then(({ data }) => {
          this.eventos = data.itens
        })
        .catch(() => {
          this.$notifyError('Erro ao buscar os eventos do calendário.')
        })
    },

    adicionarEvento() {
      this.dialogAdicionarEvento = true;
    },
    salvarEvento() {
      const { dataInicio, dataFim, eventosSelecionados } = this.formEvento;
      if (!dataInicio || !dataFim || !eventosSelecionados?.length) {
        this.$notifyWarning('Preencha todos os campos obrigatórios.');
        return;
      }
      const inicio = new Date(dataInicio);
      const fim = new Date(dataFim);
      if (fim < inicio) {
        this.$notifyWarning('A data final não pode ser anterior à data inicial do evento.');
        return;
      }
      this.$swal({
        text: 'Deseja cadastrar o(s) evento(s) no calendário?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar',
      }).then(result => {
        if (result) {
          const payload = {
            dataInicio: this.formEvento.dataInicio,
            dataFim: this.formEvento.dataFim,
            eventos: this.formEvento.eventosSelecionados.map(e => e.id)
          };
          this.$cadastrarEventoGerenciarCalendario(this.content.id, payload)
            .then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.dialogAdicionarEvento = false;
              this.resetarFormEvento();
              this.buscarCalendario(this.content.id);
            })
          .catch(({data}) => {
            this.$notifyError(data.mensagem);
          });
        }
      });
    },
    resetarFormEvento() {
      this.formEvento = {
        dataInicio: null,
        dataFim: null,
        periodo: false,
        eventosSelecionados: [],
      };
    },
    voltar() {
      this.$router.push({ name: 'Calendário' });
    }
  },
  mounted() {
    const id = this.$route.params.id;
    if (id) {
      this.buscarCalendario(id);
      this.buscarEventos();
    }
  }
};
</script>
